import { render, staticRenderFns } from "./LawCounterPartyAttorneyList.vue?vue&type=template&id=5c47f9b0&"
import script from "./LawCounterPartyAttorneyList.vue?vue&type=script&lang=js&"
export * from "./LawCounterPartyAttorneyList.vue?vue&type=script&lang=js&"
import style0 from "./LawCounterPartyAttorneyList.vue?vue&type=style&index=0&id=5c47f9b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports